export const TOGATHER_THEME_NAME = 'Togather — Base';
